import { createContext } from "react";

const rewardContext = createContext();

export default rewardContext;
